import {
  FETCH_SAVE_AREA_TEMPLATE_REQUEST,
  FETCH_SAVE_AREA_TEMPLATE_SUCCESS,
  FETCH_SAVE_AREA_TEMPLATE_FAILURE,
} from './saveAreaTemplateTypes'

const initialState = {
  loading: false,
  isSaveAreaTemplateSuccess: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_SAVE_AREA_TEMPLATE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_SAVE_AREA_TEMPLATE_SUCCESS : return {
      ...state,
      isSaveAreaTemplateSuccess: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_SAVE_AREA_TEMPLATE_FAILURE : return {
      ...state,
      loading: false,
      isSaveAreaTemplateSuccess: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
